// extracted by mini-css-extract-plugin
export default {"container":"ReactivateAccount_container__Oy6hK","details":"ReactivateAccount_details__SoJAH"};